(function() {
    'use strict';

    angular
        .module('app')
        .controller('forgetPwdModalController', forgetPwdModalController);

    function forgetPwdModalController($uibModalInstance, $uibModal, sysCode, loginService,
        $rootScope, e2eService, enumService, iAmNotRobot) {
        var vm = this;
        vm.sendMail = sendMail;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.forgetAutoFill = forgetAutoFill;
        vm.iAmNotRobot = iAmNotRobot;

        onInit();

        function onInit() {
            vm.data = {};
            vm.state = 'typeAccount';
            vm.data.target = 1;
        }

        function specialKeywordVerificationUserAccount(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }

        function sendMail() {

            if(specialKeywordVerificationUserAccount($('#inputUserAccount').val()))
            {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            }
            else if(specialKeywordVerification($('#inputVerify').val()))
            {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }
            
            //console.log('sendMail recaptcha:',vm.reCaptcha);
            if($('#inputVerify').val().length == 4){
                //將登入帳號轉成小寫
                if (vm.data.userAccount.indexOf('@') >= 0){
                    vm.data.userAccount = vm.data.userAccount.toLowerCase();
                }

                var params = {
                    userAccount: vm.data.userAccount,
                    sysCode: sysCode,
                    target: vm.data.target,
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };
                
                loginService.forgetPWD(params).then(function(data) {

                    if (data) {
                        switch (parseInt(params.target)) {
                            case enumService.sendTarget.email:
                            // console.log(data);
                                toastr.success($rootScope.translate.commonAlreadySendMail);
                                break;
                            case enumService.sendTarget.sms:
                                toastr.success($rootScope.translate.commonAlreadySendSMS);
                                break;
                        }
                        
                        return data;
                    }
                }).then(function(data) {
                    if (data && params.target !== enumService.sendTarget.email) {
                        vm.state = 'directEditPwd';
                    }else
                    {
                        $uibModalInstance.dismiss('cancel');
                    }
                });

                
            }else
            {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
                
            }
        }

        function submit() {

            vm.data.sysCode = sysCode;
            loginService.directModifyUserPassword(vm.data).then(function(data) {
                if (data) {
                    toastr.success($rootScope.translate.commonEditPwdSuccess);
                    $uibModalInstance.close('ok');
                }
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');            
        }

        function forgetAutoFill() {
            e2eService.forgetPwd(vm.data);
        }
    }
})();
